// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"66cc8fec","227":"6ae7c92d","453":"9854e1d4","871":"d83d766c"}[chunkId] + ".chunk.js";
};